var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column",class:_vm.columnSize},[_c('base-tag-input',{attrs:{"value":_vm.value,"prepend":[
      { name: 'All' },
      { name: 'Any' } ],"horizontal":"","size":"is-small","type":_vm.active ? 'is-info' : '',"custom-class":_vm.active ? 'has-text-info' : ''},on:{"add":_vm.add,"remove":_vm.remove}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7debe510","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderFilter/Field/OrderFilterFieldTags.vue
// module id = null
// module chunks = 